export const Hamburger = () => {
    return (
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 16V14.5H20V16H0ZM0 8.75V7.25H20V8.75H0ZM0 1.5V0H20V1.5H0Z" fill="#2B3939" />
        </svg>
    );
};
